import React from "react";
import ReactInputMask from "react-input-mask";
import Modal from "../../../../../_components/Modal";
import { Input, Select, Button, Typography } from "../../../../../design-system";
import { colors } from "../../../../../design-system/theme/colors";
import { toast } from "react-toastify";
import StateLocation from "../../../../../_components/Address/StateLocation";
import CityLocation from "../../../../../_components/Address/CityLocation";
import { createTransporter, updateTransporter } from "../../../../../api/nfe";

export default (props) => {
	const ref = React.useRef(null);
	const [loading, setLoading] = React.useState(false);
	const [show, setShow] = React.useState(false);
	const [data, setData] = React.useState({ type: "pf" });

	function onHandleShow() {
		if (loading) {
			return;
		}
		if (show === true) {
			if (props.onHide) {
				props.onHide();
				setData({ type: "pf" });
				setShow(false);
			}
		} else {
			setShow(true);
		}
	}
    
	function onChange(e) {
		let { name, value } = e.target;
		let tempData = { ...data };

		if (name === 'type') {
			tempData['cpf_cnpj'] = '';
		}

		if (["cpf_cnpj", "state_registry"].includes(name)) {
			const regex = /\D+/g;
			value = value.replace(regex, '');
		}

		tempData[name] = value;
		setData(tempData);
	}

	function setStateLocation(state_location, stateName, stateCode) {
		setData({
			...data,
			state_location,
			stateCode,
			city_location: "",
			city_name: "",
		});
	}

	function setCityLocation(city_location, city_name) {
		setData({
			...data,
			city_location,
			city_name,
		});
	}

	function onToast(message = "", type = "success") {
		const toastId = 2010;
		toast[type](message, {
			toastId,
			position: "top-center",
		});
	}

	function onSave() {
		let required = [
			"name",
			"cpf_cnpj",
			"state_location",
			"city_location",
			"street",
		].concat(data.type === "pj" ? ["state_registry"] : []);
		
        let errors = [];
		for (let key of required) {
			if (!data[key]) {
				errors.push(key);
			} else if (key === "cpf_cnpj") {
				if (
					(data.type === "pf" && data[key].length !== 11) ||
					(data.type === "pj" && data[key].length !== 14)
				) {
					errors.push(key);
				}
			}
		}

		if (errors.length > 0) {
            onToast("Por favor, preencha todos os campos obrigatórios corretamente.", "error");
			return;
		}

		setLoading(true);
		const request = data.id ? updateTransporter : createTransporter;
		request(data)
			.then((resp) => {
				onToast("Transportadora salva!");
				setTimeout(() => {
					window.location.reload();
				}, 2000);
			})
			.catch((error) => {
                onToast("Erro ao salvar transportadora.", "error");
            })
			.finally(() => {
				setTimeout(() => {
					setLoading(false);
				}, 3000);
			});
	}

	function onShow() {
		if (props.show === true) {
			if (props.data) {
				const cpf_cnpj = props.data.cnpj || props.data.cpf;
				const type = cpf_cnpj ? (cpf_cnpj.length === 14 ? "pj" : "pf") : "pf";
				const state_location = props.data.state_location
					? props.data.state_location.id
					: "";
				const city_location = props.data.city_location
					? props.data.city_location.id
					: "";
				const state_name = state_location
					? props.data.state_location.state_name
					: "";
				const city_name = props.data.city_location
					? props.data.city_location.city_name
					: "";
				const stateCode = props.data.state_location
					? props.data.state_location.uf_code
					: null;

				setData({
					...props.data,
					cpf_cnpj,
					type,
					state_location,
					state_name,
					city_location,
					city_name,
					stateCode
				});
				setShow(true);
			}
		}
	}

	React.useEffect(onShow, [props.show]);

	const typeOptions = [
		{ label: "Pessoa Jurídica", value: "pj" },
		{ label: "Pessoa Física", value: "pf" },
	];

	return (
		<div ref={ref}>
			<Button variant="primary" onClick={onHandleShow} disabled={loading}>
                Cadastrar Transportadora <i className="fa fa-plus ml-2" />
            </Button>
			<Modal title="Transportadora" onHide={onHandleShow} show={show}>
				<div className="container-fluid p-0">
					<div className="row">
						<div className="col-md-6 mb-4">
							<Select
								label="Tipo de transportadora"
								name="type"
								options={typeOptions}
								onChange={onChange}
								value={data.type}
								disabled={loading}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-md-4 mb-4">
							<Input
								label="Nome/Razão Social"
								name="name"
								onChange={onChange}
								value={data.name || ""}
								disabled={loading}
								placeholder="Nome da transportadora"
							/>
						</div>
						<div className="col-md-4 mb-4">
                            <Typography variant="paragraph" style={{ fontSize: '0.875rem', color: colors.brandDarkBlue, marginBottom: '4px', fontWeight: 600, display: 'block' }}>
                                {data.type === "pf" ? "CPF" : "CNPJ"} da transportadora
                            </Typography>
							<ReactInputMask
								name="cpf_cnpj"
								onChange={onChange}
								value={data.cpf_cnpj || ""}
								disabled={loading}
								mask={data.type === "pf" ? "999.999.999-99" : "99.999.999/9999-99"}
								className="form-control"
                                style={{
                                    border: 'none',
                                    borderBottom: `2px solid ${colors.brandLightGray}`,
                                    backgroundColor: 'transparent',
                                    width: '100%',
                                    color: colors.dark,
                                    outline: 'none',
                                    padding: '0.5rem 0',
                                    fontSize: '1rem',
                                    fontFamily: "'Nunito', sans-serif"
                                }}
							/>
						</div>
						<div className="col-md-4 mb-4">
							<Input
								label="Inscrição Estadual (IE)"
								name="state_registry"
								onChange={onChange}
								value={data.state_registry || ""}
								disabled={loading}
								placeholder="IE da transportadora"
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-md-4 mb-4">
							<StateLocation
								selected={data.state_location || data.state_name}
								disabled={loading}
								onChange={setStateLocation}
							/>
						</div>
						<div className="col-md-4 mb-4">
							<CityLocation
								cityId={data.city_location}
								defaultInputValue={data.city_name}
								disabled={loading}
								onChange={setCityLocation}
								stateCode={data.stateCode}
							/>
						</div>
						<div className="col-md-4 mb-4">
							<Input
								label="Endereço"
								name="street"
								onChange={onChange}
								value={data.street || ""}
								disabled={loading}
								placeholder="Rua, número, bairro..."
							/>
						</div>
					</div>
					<div className="row mt-4">
						<div className="col-12 d-flex justify-content-end">
							<Button variant="primary" disabled={loading} onClick={onSave}>
								{loading ? "Salvando..." : "Salvar Transportadora"}
							</Button>
						</div>
					</div>
				</div>
			</Modal>
		</div>
	);
};




// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Transport/Transporter/index.jsx